<template>
  <v-card>
      <v-card-text>
          <v-row>
              <v-col>
                  <export-request-latency-response-chart :statistics="statistic"></export-request-latency-response-chart>
              </v-col>
          </v-row>
      </v-card-text>
  </v-card>
</template>

<script>
import ExportRequestLatencyResponseChart from "../../components/statistic/ExportRequestLatencyResponseChart.vue";
import * as api from '@/api/admin/debtStatistic';
export default {
    name: "ExportRequestStatisticPage",
    components: {ExportRequestLatencyResponseChart},
    data(){
        return {
            statistic: []
        }
    },
    created() {
        this.load();
    },
    methods:{
        async load(){
            let response = await api.exportDebtRequestStatisticExportResponseLatency();
            this.statistic.splice(0, this.statistic.length, ...response.data);
        }
    }
}
</script>

<style scoped>

</style>